import React, {useMemo} from 'react'
import styled from 'styled-components'
import {IMAGE_ASSET} from 'consts'
import {useTranslation} from 'i18n'
import {getWhatsAppLink, getInstagramLink} from 'utils'
import {Image, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

export interface GiftShopSettingSupportProps {
  isHorizontal?: boolean
  width?: string
  isBordered?: boolean
}

const StyledInBalanceContainer = styled.div<GiftShopSettingSupportProps>`
  width: 100%;
  padding: ${convertUnit(8)} 0;
  box-sizing: border-box;
  background-color: ${({theme}) => theme.white_1};
  border-top: 1px solid ${({theme}) => theme.gray_1};
  border-bottom: 1px solid ${({theme}) => theme.gray_1};
`

const StyledLabelEndContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: ${convertUnit(8)};
`

const StyledImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: ${convertUnit(20)};
  width: ${convertUnit(20)};
  padding: ${convertUnit(12)};
  border-radius: ${convertUnit(28)};
  background-color: ${({theme}) => theme.white_3};
  margin-right: ${convertUnit(12)};
  cursor: pointer;
`

const StyledParagraph = styled(Paragraph)`
  margin-right: ${convertUnit(17)};
`

const StyledImage = styled(Image)`
  width: ${convertUnit(20)};
  height: ${convertUnit(20)};
`

const StyledLink = styled.a`
  text-decoration: none;
`

export default function GiftShopSettingSupportHorizontal() {
  const {translate} = useTranslation()
  const whatsappImg = IMAGE_ASSET('giftshop', 'whats-app.png')
  const instagramImg = IMAGE_ASSET('giftshop', 'instagram.png')

  const handleRenderLink = useMemo(
    () => (
      <>
        <StyledLink href={getWhatsAppLink()} target="_blank">
          <StyledImagesContainer>
            <StyledImage src={whatsappImg} alt="whats-app" />
          </StyledImagesContainer>
        </StyledLink>
        <StyledLink href={getInstagramLink()} target="_blank">
          <StyledImagesContainer>
            <StyledImage src={instagramImg} alt="instagram" />
          </StyledImagesContainer>
        </StyledLink>
      </>
    ),
    [instagramImg, whatsappImg],
  )

  return (
    <StyledInBalanceContainer>
      <StyledLabelEndContainer>
        <StyledParagraph color="gray_5" fontSize="s" fontWeight="bold">
          {translate('giftShop:supportTitle')}
        </StyledParagraph>
        {handleRenderLink}
      </StyledLabelEndContainer>
    </StyledInBalanceContainer>
  )
}
